import Select from "../Select/Select";

interface DropdownProps {
  options: any[];
  /** Handed a synthetic {target:{name,id,value}} - see the note below. */
  onChange: any;
  value: any;
  label?: string;
  name?: string;
  id?: string;
  className?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
}

/**
 * The same control as the Select atom - our own listbox rather than a native
 * <select>, so the options render as a styled popover instead of browser UI.
 *
 * It stays a separate component because its thirteen call sites expect an
 * event-shaped onChange (`e.target.value`, and in a few places
 * `e.target.name`), whereas Select hands over the bare value. The adapter
 * below is the whole difference.
 */
const Dropdown = ({
  options,
  onChange,
  value,
  label,
  name,
  id,
  className,
  placeholder,
  error,
  helperText,
  disabled,
  required,
}: DropdownProps) => {
  // The native version carried an empty <option> that doubled as "clear".
  // Offered only once something is chosen, so an untouched field still shows
  // the placeholder in its muted styling rather than a selected-looking row.
  const items = value
    ? [{ label: placeholder || "Select", value: "" }, ...(options || [])]
    : options || [];

  return (
    <Select
      options={items}
      value={value}
      label={label}
      name={name}
      id={id}
      wrapperClassName={className}
      placeholder={placeholder || "Select"}
      error={error}
      // The native version only ever showed this text as an error message.
      helperText={error ? helperText : undefined}
      disabled={disabled}
      required={required}
      onChange={(selectedValue: any) =>
        onChange({ target: { name, id, value: selectedValue } })
      }
    />
  );
};

export default Dropdown;
